import { useTonAddress } from "@tonconnect/ui-react"
import { FC, useEffect } from "react"
import { useGetUserDataQuery } from "@/store/apis/userAPI"
import { useAttachWalletMutation } from "@/store/apis/withdrawalAPI"

/** Silent side-effect: posts attachWallet when TonConnect reports a new address. */
export const WalletAutoAttach: FC = () => {
  const address = useTonAddress()
  const { walletAddress, ready } = useGetUserDataQuery(undefined, {
    selectFromResult: ({ data, isSuccess }) => ({
      walletAddress: data?.wallets?.telegram,
      ready: isSuccess
    })
  })
  const [attachWallet] = useAttachWalletMutation()

  useEffect(() => {
    if (!ready) return // wait for profile
    if (!address) return // no TonConnect session
    if (address === walletAddress) return // already synced

    attachWallet({ walletType: "telegram", wallet: address })
      .unwrap()
      .catch((e) => console.error("WalletAutoAttach: attachWallet failed", e))
  }, [address, walletAddress, ready, attachWallet])

  return null
}
